import { Component } from '@angular/core';
import {BaseComponent} from "../../views/base.component";
import {EventsService} from "../../lib/EventsService";
import {ActivatedRoute} from "@angular/router";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {TranslateService} from "../../translate/translate.service";
import { BillingService2 } from "../billing.service";

class History {
	date: string = '';
	amount: number = 0;
	amountPerMonth: number = 0;
	monthCount: number = 0;
	tariffVariant: string = '';
	dateTo: string = '';
}


class BananceStat {
	date           : string = '';
	sum            : number = 0;
	balance        : number = 0;
	amountPerMonth : number = 0;
	user           : string[] = [];
	median         : number = 0;
	history        : History[] = [];
}


@Component({
	selector: 'app-balance',
	templateUrl: './balance.component.html'
})
export class BalanceComponent extends BaseComponent {

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public filter: FilterFormService,
		public translate: TranslateService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
	}
	
	async getData() {
		let me = this;
		
		me.isLoad = true;
		const { stats } = await me.service2.balance.stats(
			me.filter.filterParams
		).toPromise();
		me.stats = <BananceStat[]>stats;
		me.isLoad = false;
	}
}
